import React, { useState } from "react";

import "./styles.less";

import { useTranslation } from "react-i18next";
import { Column, Table } from "../../../../components/NormalTable";

export const SolutionTransfer = (props) => {
  const { t } = useTranslation();
  const transferArr = [
    {
      title: t("solution.auth0.transfer.step1.title"),
      description: t("solution.auth0.transfer.step1.subtitle"),
    },
    {
      title: t("solution.auth0.transfer.step2.title"),
      description: t("solution.auth0.transfer.step2.subtitle"),
    },
    {
      title: t("solution.auth0.transfer.step3.title"),
      description: t("solution.auth0.transfer.step3.subtitle"),
    },
    {
      title: t("solution.auth0.transfer.step4.title"),
      description: t("solution.auth0.transfer.step4.subtitle"),
    },
  ];
  return (
    <>
      <div className="solution-transfer">
        <div className="inner">
          <div className="solution-table-title">
            {t("solution.auth0.transfer.title")}
          </div>
          <div className="solution-table-subtitle">
            {t("solution.auth0.transfer.description1")}
            <br />
            {t("solution.auth0.transfer.description2")}
            <a
              href="https://www.authing.cn/authingform?tagFrom=auth0立即咨询"
              target="_blank"
            >
              {t("solution.auth0.transfer.consult")}
              <i className="icon website-icon website-arrow-right-s-fill1"></i>
            </a>
          </div>
          <div className="line-bar-warp">
            {transferArr.map((item, index) => (
              <div className="line-bar">
                <div className="line-order"></div>
                <div className="line-order-title">
                  <i className="line-order-icon">0{index + 1}</i>
                  <span>{item.title}</span>
                </div>
                <div className="line-order-description">{item.description}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
